import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';

interface Props {
  href: string;
}

function PrivacyPolicyLink({ href }: Props) {
  return (
    <T
      kind="<link1>Privacy ..."
      link1={(content) => (
        <a
          data-testid="footer_privacy-policy-link"
          data-test-privacy-policy-link={true}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography
            data-testid="Privacy Policy"
            className="text-neutral-900 underline hover:text-primary-500"
            variant="bodyMedium"
            fontWeight="semibold"
            as="span"
          >
            {content}
          </Typography>
        </a>
      )}
    />
  );
}

export default observer(PrivacyPolicyLink);
